<template>
    <Modal
        id="view-webhook-call-modal"
        v-model:open="open"
        title="modal_title_view_webhook_call"
        @cancel="cancel"
    >
        <div
            class="flex h-auto w-full flex-col items-start justify-start space-y-2"
        >
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500"> {{ $t('id') }}: </span>
                <p>{{ webhookCall?.id }}</p>
            </div>
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('status') }}:
                </span>
                <p>{{ webhookCall?.status }}</p>
            </div>
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('action') }}:
                </span>
                <p>{{ webhookCall?.action }}</p>
            </div>
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('platform_name') }}:
                </span>
                <p>{{ webhookCall?.platform_name }}</p>
            </div>
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('last_attempted_at') }}:
                </span>
                <p>
                    {{
                        moment(webhookCall?.attempted_at).format(
                            'DD.MM.yyyy HH:mm'
                        )
                    }}
                </p>
            </div>
            <div
                class="flex h-10 w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('attempt_number') }}:
                </span>
                <p>{{ webhookCall?.attempt_number }}</p>
            </div>
            <div
                class="flex h-auto w-full items-center justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <span class="font-bold text-gray-500"> {{ $t('url') }}: </span>
                <input
                    v-model="url"
                    readonly
                    class="w-full border-none bg-transparent px-2 focus:border-none focus:outline-none focus:ring-0"
                />
            </div>
            <div
                class="flex h-auto w-full flex-col items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <span class="font-bold text-gray-500">
                    {{ $t('payload') }}:
                </span>
                <VueJsonPretty
                    :data="webhookCall?.payload"
                    :deep="1"
                />
            </div>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@src/components'
import { WebhookCall } from '@src/utils/api/webhookCalls'
import { useVModels } from '@vueuse/core'
import moment from 'moment'
import { ref } from 'vue'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

const props = defineProps<{
    open: boolean
    webhookCall: WebhookCall
}>()

const emit = defineEmits(['update:open', 'cancel'])

const { open } = useVModels(props, emit)

function cancel() {
    emit('cancel')
}

const url = ref(props.webhookCall.url)
</script>
